/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react"
import { IFloatContainerProps } from "./FloatContainer"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { getCssDemention } from "src/libs/utilities"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ILanding, ILandingFloat, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"


const FloatPositionContainer = ({ ...props }: IFloatContainerProps ) : JSX.Element => { 
    const { i } = props
    const { id, style } = props.float
    const [float, setFloat] = useState<ILandingFloat>( props.float ) 
    const position = float.position || {};//usePosition(float)
    
    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => {  
                currentLanding.sections.forEach(section => { 
                    section.floats.forEach(fl => {
                        if(fl.id === props.float.id) { 
                            setFloat(fl)
                        }
                    }) 
                }) 
            }, 
            {} 
        )
        return () => {
            unsubscribe();
        };
    }, [])

    const _style        = useMemo(() => {
        let st = { ...( position.style ? position.style : style ) }
        delete st.transform
        return st
    },[ position.style ])

    useEffect(() => {
        addCSSClass(
            `float-position-${ id }-${ i }`,
            `.landing-float-position-${ id }-${ i } {
                position: absolute; 
                width: ${getCssDemention(position.width)};
                height: ${getCssDemention(position.height)}; 
                ${getPositionX()}
                ${getPositionY()}
            } 
            .float-${float.id} {
                width: ${getCssDemention(position.width)};
                height: ${getCssDemention(position.height)};
            }
            `
        )
        return () => {
            removeCSSClass( `float-position-${ id }-${ i }` )
        } 
    }, [ position ])

    const getPositionX = () => {
        if( typeof position.left !== "undefined" ) {
            return `left: ${getCssDemention(position.left,   "auto" )}; right: auto;`
        }
        else if( typeof position.right !== "undefined" ) {
            return `right: ${getCssDemention(position.right, "auto" )}; left: auto;`
        }
        return ""
    }
    const getPositionY = () => {
        if( typeof position.top !== "undefined" ) {
            return `top: ${getCssDemention(position.top )}; bottom: auto;`
        }
        else if( typeof position.bottom !== "undefined" ) {
            return `bottom: ${getCssDemention(position.bottom )}; top: auto;;`
        }
        return ""
    }
    
    const transform = `scale(${ position.scale || 1 }) rotate(${ position.rotate || 0 }deg) skew( ${position.skewY || 0}deg, ${position.skewY || 0 }deg)`
    const __style = { 
        ..._style, 
        transform,
        opacity:`${ position.opacity || 1 }`,
        zIndex: `${ position.z || props.i + (props.section?.data.length || 0) }`,
    } 
    
    /* css class .landing-edit-cont - edit.select container for get bounds */
    return <div 
            className={`landing-float-position-container landing-float-position-${ id }-${ i } landing-edit-cont`}
            style={__style}
            data-float-id={ id }
        >
        {props.children }
    </div>
}

export default FloatPositionContainer